export default {
  '--tab-inactive-color': 'rgba(255, 255, 255, .65)'
};